import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "@/redux/slices/userSlices";
import cloud_1 from "@/assets/cloud_1.png";
import cloud_2 from "@/assets/cloud_2.png";
import cloud_3 from "@/assets/cloud_3.png";
import cum_xe from "@/assets/cum_xe.png";
import btn_option_thaydau from "@/assets/btn_option_thaydau.png";
import btn_option_suppervoucher from "@/assets/btn_option_suppervoucher.png";

const Manager: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onClickOptionThayDau = () => {
    navigate("/Manage/PhieuThayDau");
  };
  const onClickOptionSupervoucher = () => {
    navigate("/Manage/SuperVoucher");
  };

  return (
    <>
      <div className="manager-container relative mb-36 min_h_auto">
        {/* Cloud 1 - Top Right */}
        <div className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
          <img src={cloud_1} className="w-28" alt="Cloud 1" />
        </div>

        {/* Cloud 2 - Bottom Right */}
        <div className="absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/2">
          <img src={cloud_2} className="w-28" alt="Cloud 2" />
        </div>

        {/* Cloud 3 - Bottom Left */}
        <div className="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/2">
          <img src={cloud_3} className="w-28" alt="Cloud 3" />
        </div>
        <div className="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/2">
          <img src={cum_xe} className="w-[90%]" alt="Cloud 3" />
        </div>
        <div className="w-full py-4">
          <img
            src={btn_option_thaydau}
            className="w-[50%] mx-auto cursor-pointer"
            alt="Cloud 2"
            onClick={onClickOptionThayDau}
          />
          <img
            src={btn_option_suppervoucher}
            className="w-[50%] mx-auto cursor-pointer"
            alt="Cloud 2"
            onClick={onClickOptionSupervoucher}
          />
        </div>
        <div className="flex gap-4 justify-end">
          <Link to={"/Manage/ChangePassword"} className="check-time-activated">
            Đổi mật khẩu
          </Link>
          <button className="logout" onClick={() => dispatch(logout())}>
            Đăng Xuất
          </button>
        </div>
      </div>
    </>
  );
};
export default Manager;
